import * as React from "react";
import FluidFrame from "../FluidFrame";
import DefaultHead from "../DefaultHead";
import UnreadMessageCount from "./UnreadMessageCount";
import PreviewCloseButton from "../MessagePreview/PreviewCloseButton";
import PreviewMessage from "../MessagePreview/PreviewMessage";
import sleep from "../../helpers/sleep";
import useConfig from "../../hooks/useConfig";

interface Props {
  messages: string[];
  agentHeadshotUrl: string;
  messagePreviewDisabled: boolean;
  onExpand: () => void;
  onCloseMessagePreview: () => void;
}

function BubbleInviteLauncher(props: Props) {
  const config = useConfig();
  const [visibleMessages, setVisibleMessages] = React.useState<string[]>([]);

  let isSubscribed = true;
  React.useEffect(() => {
    simulateMessages();
    return () => {
      isSubscribed = false;
    };
  }, []);

  async function simulateMessages() {
    const temp = [];
    await sleep(1000);
    for (const message of props.messages) {
      temp.push(message);
      if (isSubscribed) {
        setVisibleMessages([...temp]);
      }
      await sleep(3000);
    }
  }

  function renderMessagePreview() {
    if (props.messagePreviewDisabled) {
      return;
    }

    if (!visibleMessages.length) {
      return;
    }

    return (
      <div className="velaro-message-preview-frame">
        <FluidFrame head={<DefaultHead />}>
          <div
            role="dialog"
            className="velaro-preview-messages velaro-clearfix"
          >
            <PreviewCloseButton onClose={props.onCloseMessagePreview} />
            <div role="button" onClick={props.onExpand}>
              {visibleMessages.map((message, i) => (
                <PreviewMessage key={i} message={message} />
              ))}
            </div>
          </div>
        </FluidFrame>
      </div>
    );
  }

  function getImageUrl() {
    if (config.ChattingLauncherType === "AgentHeadshot") {
      return props.agentHeadshotUrl;
    }

    if (!config.ChattingLauncherCustomImageUrl) {
      return props.agentHeadshotUrl;
    }

    return config.ChattingLauncherCustomImageUrl;
  }

  return (
    <div className="velaro-launcher-container">
      <div className="velaro-launcher-frame velaro-chatting-launcher-frame">
        {renderMessagePreview()}
        <UnreadMessageCount unreadMessageCount={visibleMessages.length} />
        <div className="velaro-bubble-invite-launcher-frame">
          <FluidFrame head={<DefaultHead />}>
            <div
              className="velaro-chatting-launcher"
              tabIndex={0}
              role="button"
              aria-label="live chat"
              onClick={props.onExpand}
              onKeyDown={e => {
                return e.keyCode !== 13 || props.onExpand();
              }}
            >
              <img src={getImageUrl()} alt="" role="presentation" />
            </div>
          </FluidFrame>
        </div>
      </div>
    </div>
  );
}

export default BubbleInviteLauncher;
